import { ResourceContainer } from 'ohzi-core';
import { SceneManager } from 'ohzi-core';
import { Time } from 'ohzi-core';

import { Sprite } from 'three';
import { SpriteMaterial } from 'three';
import { sRGBEncoding } from 'three';
import { Vector3 } from 'three';

export default class Icon2D extends Sprite {

	constructor (data, sub_title, position_owner, building_owner, icon, scale) {
		const map = ResourceContainer.get_resource(icon + "-marker");
		map.encoding = sRGBEncoding;
		const html_image = ResourceContainer.get_resource(icon + "-html-image");

		const material = new SpriteMaterial( {
			map: map,
			transparent : true,
			opacity : 1,
			toneMapped : false
		} );

		const material_wave = new SpriteMaterial( {
			map: ResourceContainer.get_resource("radio-wave"),
			transparent : true,
			opacity : 1,
			//color : "#ffae26",
			toneMapped : false
		} );

		super(material);
		this.data = data;
		this.no_label = data.no_label;
		this.wave_1 = new Sprite(material_wave.clone());
		this.wave_2 = new Sprite(material_wave.clone());
		this.wave_1.owner = building_owner;
		this.wave_2.owner = building_owner;
		//this.wave_3 = new Sprite(material_wave);
		this.add(this.wave_1)
		this.add(this.wave_2)
		//this.add(this.wave_3)

		this.wave_1.position.set(0,0.1,0);
		this.wave_2.position.set(0,0.1,0);
		//this.wave_3.position.set(0,0.1,0);

		let image_url = 
		this.last_opacity = 1;
		this.labelObject = {
			title: sub_title,
			subtitle: data.subtitle,
			text: data.text,
			img_slug: html_image ? html_image.image.src : '',
			url : data.url
		}

		this.final_scale = scale || 13;
		SceneManager.ui.add( this );
		this.owner = building_owner;

		position_owner.updateMatrixWorld(true)
		position_owner.getWorldPosition(this.position)
		this.position.y += this.final_scale;
		this.scale_1 = 0.0;
		this.scale_2 = 0.5;

		this.faded_out = false;
	}

	fade_out (lerp) {
		//if (this.no_label && this.faded_out)
			this.scale.setScalar((1-lerp) * this.final_scale);

		if (lerp === 1) {
			this.faded_out = false;
		}
	}

	fade_in (lerp) {
		this.scale.setScalar(lerp * this.final_scale);
		this.faded_out = true;

	}

	update() {

		this.scale_1 += Time.delta_time * 0.4;
		this.scale_2 += Time.delta_time * 0.4;
		//this.scale_3 += Time.delta_time * 0.4;

		if (this.scale_1 > 1) this.scale_1 = 0.0;
		if (this.scale_2 > 1) this.scale_2 = 0.0;
		//if (this.scale_3 > 1) this.scale_3 = 0.0;

		this.wave_1.scale.setScalar(this.scale_1 * 0.5 + 0.9);
		this.wave_2.scale.setScalar(this.scale_2 * 0.5 + 0.9);
		//this.wave_3.scale.setScalar(this.scale_3 * 1.2 + 0.9);

		this.wave_1.material.opacity = Math.sin(this.scale_1 * Math.PI)//1// - Math.pow((this.scale_1 - 0.5),2);
		this.wave_2.material.opacity = Math.sin(this.scale_2 * Math.PI)//1// - Math.pow((this.scale_2 - 0.5),2);
		//this.wave_3.material.opacity = Math.sin(this.scale_3 * Math.PI)//1// - Math.pow((this.scale_3 - 0.5),2);
	}
}